import api from './api';
import { fetchPage } from './pagedParams';

const returnService = {
  getReturns: async () => (await api.get('/admin/returns')).data,
  getReturnById: async (id) => (await api.get(`/admin/returns/${id}`)).data,
  createReturn: async (data) => (await api.post('/admin/returns', data)).data,
  approveReturn: async (id, adminNote) =>
    (await api.patch(`/admin/returns/${id}/approve`, adminNote ? { adminNote } : {})).data,
  rejectReturn: async (id, rejectionReason) =>
    (await api.patch(`/admin/returns/${id}/reject`, { rejectionReason })).data,
  completeReturn: async (id) => (await api.patch(`/admin/returns/${id}/complete`)).data,

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getReturnsPage: (params) => fetchPage('/admin/returns/paged', params),

};

export default returnService;
